/* eslint-disable */
import { I18N_LANG_AR_AE, I18N_LANG_EN_AU, I18N_LANG_ZH_CN } from '../../Constants/I18n/I18n.constants';
import httpStatus from '../../Support/Http/Status/HttpStatus.support';
import i18nStore from '../../Support/I18n/Store/I18nStore.support';

/**
 * The `key` to use to store the `translations`
 */
const key = `ErrorPage`;

i18nStore.add(I18N_LANG_AR_AE, key, {
  ErrorMessage: ({ status }) => {
    if (status === httpStatus.NOT_FOUND) {
      return `خطأ: ${status} الصفحة غير موجودة`;
    }
    return `خطأ: ${status} حدث خطأ ما`;
  },
  PageHeading: ({ name }) => name,
  PageTitle: `خطأ`,
  SubMessage: ` عذرًا ، تم نقل الصفحة التي تبحث عنها أو لم تكن موجودة`,
  SubMessageRedirect: `العودة إلى المنزل `,
});

i18nStore.add(I18N_LANG_EN_AU, key, {
  ErrorMessage: ({ status }) => {
    if (status === httpStatus.NOT_FOUND) {
      return `Error: ${status} Page Not Found!`;
    }
    return `Error: ${status} Something went wrong`;
  },
  PageHeading: ({ name }) => name,
  PageTitle: `Error`,
  SubMessage: ` Sorry, the page you're looking for was moved or does not exist.`,
  SubMessageRedirect: `Return to Home `,
});

i18nStore.add(I18N_LANG_ZH_CN, key, {
  ErrorMessage: ({ status }) => {
    if (status === httpStatus.NOT_FOUND) {
      return `错误: ${status} 找不到網頁`;
    }
    return `错误: ${status} 出了点问题`;
  },
  PageHeading: ({ name }) => name,
  PageTitle: `錯誤`,
  SubMessage: ` 抱歉，您要查找的頁面已移動或不存在`,
  SubMessageRedirect: `回到家 `,
});
